import { Block } from "./block";

export function TicketBrief() {
  return <Block type="Ticket Brief">TicketBrief</Block>;
}
